// Generated by purs version 0.13.8
"use strict";
var Control_Alt = require("../Control.Alt/index.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Apply = require("../Control.Apply/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Category = require("../Control.Category/index.js");
var Control_Semigroupoid = require("../Control.Semigroupoid/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Heterogeneous_Mapping = require("../Heterogeneous.Mapping/index.js");
var Validation = function (x) {
    return x;
};
var EmptyValidators = (function () {
    function EmptyValidators() {

    };
    EmptyValidators.value = new EmptyValidators();
    return EmptyValidators;
})();
var semigroupValidation = function (dictSemigroup) {
    return new Data_Semigroup.Semigroup(function (v) {
        return function (v1) {
            return function (form) {
                return function (i) {
                    return Data_Semigroup.append(dictSemigroup)(v(form)(i))(v1(form)(i));
                };
            };
        };
    });
};
var noValidators = function (dictMonad) {
    return function (dictRowToList) {
        return function (dictNewtype) {
            return function (dictNewtype1) {
                return function (dictMapRecordWithIndex) {
                    var $38 = Data_Newtype.wrap(dictNewtype);
                    var $39 = Heterogeneous_Mapping.hmap(Heterogeneous_Mapping.hmapRecord()(dictMapRecordWithIndex))(EmptyValidators.value);
                    var $40 = Data_Newtype.unwrap(dictNewtype1);
                    return function ($41) {
                        return $38($39($40($41)));
                    };
                };
            };
        };
    };
};
var newtypeValidation = new Data_Newtype.Newtype(function (n) {
    return n;
}, Validation);
var runValidation = function (dictMonad) {
    return Data_Newtype.unwrap(newtypeValidation);
};
var semigroupoidValidation = function (dictMonad) {
    return new Control_Semigroupoid.Semigroupoid(function (v1) {
        return function (v0) {
            return function (form) {
                return function (i) {
                    return Control_Bind.bind(dictMonad.Bind1())(Data_Newtype.unwrap(newtypeValidation)(v0)(form)(i))(function (eo) {
                        return Data_Either.either((function () {
                            var $42 = Control_Applicative.pure(dictMonad.Applicative0());
                            return function ($43) {
                                return $42(Data_Either.Left.create($43));
                            };
                        })())(Data_Newtype.unwrap(newtypeValidation)(v1)(form))(eo);
                    });
                };
            };
        };
    });
};
var monoidValidation = function (dictApplicative) {
    return function (dictMonoid) {
        return function (dictSemigroup) {
            return new Data_Monoid.Monoid(function () {
                return semigroupValidation(dictMonoid.Semigroup0());
            }, Validation(Data_Function["const"](Control_Applicative.pure(Control_Applicative.applicativeFn)(Data_Monoid.mempty(dictMonoid)))));
        };
    };
};
var hoistFn_ = function (dictMonad) {
    return function (f) {
        return Validation(Data_Function["const"]((function () {
            var $44 = Control_Applicative.pure(dictMonad.Applicative0());
            var $45 = Control_Applicative.pure(Data_Either.applicativeEither);
            return function ($46) {
                return $44($45(f($46)));
            };
        })()));
    };
};
var noValidation = function (dictMonad) {
    return hoistFn_(dictMonad)(Control_Category.identity(Control_Category.categoryFn));
};
var hoistFnME_ = function (dictMonad) {
    return function ($47) {
        return Validation(Data_Function["const"]($47));
    };
};
var hoistFnME = function (dictMonad) {
    return Validation;
};
var hoistFnE_ = function (dictMonad) {
    return function (f) {
        return Validation(Data_Function["const"]((function () {
            var $48 = Control_Applicative.pure(dictMonad.Applicative0());
            return function ($49) {
                return $48(f($49));
            };
        })()));
    };
};
var hoistFnE = function (dictMonad) {
    return function (f) {
        return Validation(function (form) {
            var $50 = Control_Applicative.pure(dictMonad.Applicative0());
            var $51 = f(form);
            return function ($52) {
                return $50($51($52));
            };
        });
    };
};
var hoistFn = function (dictMonad) {
    return function (f) {
        return Validation(function (form) {
            var $53 = Control_Applicative.pure(dictMonad.Applicative0());
            var $54 = Control_Applicative.pure(Data_Either.applicativeEither);
            var $55 = f(form);
            return function ($56) {
                return $53($54($55($56)));
            };
        });
    };
};
var functorValidation = function (dictFunctor) {
    return new Data_Functor.Functor(function (f) {
        return function (m) {
            return Data_Functor.map(Data_Functor.functorFn)(Data_Functor.map(Data_Functor.functorFn)(Data_Functor.map(dictFunctor)(Data_Functor.map(Data_Either.functorEither)(f))))(m);
        };
    });
};
var emptyValidators = function (dictMonad) {
    return new Heterogeneous_Mapping.Mapping(function (v) {
        return Data_Function["const"](hoistFn_(dictMonad)(Control_Category.identity(Control_Category.categoryFn)));
    });
};
var categoryValidation = function (dictMonad) {
    return new Control_Category.Category(function () {
        return semigroupoidValidation(dictMonad);
    }, Validation(function (v) {
        var $57 = Control_Applicative.pure(dictMonad.Applicative0());
        var $58 = Control_Applicative.pure(Data_Either.applicativeEither);
        return function ($59) {
            return $57($58($59));
        };
    }));
};
var applyValidation = function (dictMonad) {
    return new Control_Apply.Apply(function () {
        return functorValidation(((dictMonad.Bind1()).Apply0()).Functor0());
    }, function (vf) {
        return function (va) {
            return function (form) {
                return function (i) {
                    return Control_Bind.bind(dictMonad.Bind1())(Data_Newtype.unwrap(newtypeValidation)(vf)(form)(i))(function (vf$prime) {
                        return Control_Bind.bind(dictMonad.Bind1())(Data_Newtype.unwrap(newtypeValidation)(va)(form)(i))(function (va$prime) {
                            return Control_Applicative.pure(dictMonad.Applicative0())(Control_Apply.apply(Data_Either.applyEither)(vf$prime)(va$prime));
                        });
                    });
                };
            };
        };
    });
};
var applicativeValidation = function (dictMonad) {
    return new Control_Applicative.Applicative(function () {
        return applyValidation(dictMonad);
    }, (function () {
        var $60 = Control_Applicative.pure(dictMonad.Applicative0());
        var $61 = Control_Applicative.pure(Data_Either.applicativeEither);
        return function ($62) {
            return Validation(Data_Function["const"](Data_Function["const"]($60($61($62)))));
        };
    })());
};
var altValidation = function (dictMonad) {
    return new Control_Alt.Alt(function () {
        return functorValidation(((dictMonad.Bind1()).Apply0()).Functor0());
    }, function (v0) {
        return function (v1) {
            return function (form) {
                return function (i) {
                    return Control_Bind.bind(dictMonad.Bind1())(Data_Newtype.unwrap(newtypeValidation)(v0)(form)(i))(function (v0$prime) {
                        return Control_Bind.bind(dictMonad.Bind1())(Data_Newtype.unwrap(newtypeValidation)(v1)(form)(i))(function (v1$prime) {
                            return Control_Applicative.pure(dictMonad.Applicative0())(Control_Alt.alt(Data_Either.altEither)(v0$prime)(v1$prime));
                        });
                    });
                };
            };
        };
    });
};
module.exports = {
    Validation: Validation,
    runValidation: runValidation,
    hoistFn: hoistFn,
    hoistFn_: hoistFn_,
    hoistFnE: hoistFnE,
    hoistFnE_: hoistFnE_,
    hoistFnME: hoistFnME,
    hoistFnME_: hoistFnME_,
    noValidators: noValidators,
    noValidation: noValidation,
    EmptyValidators: EmptyValidators,
    newtypeValidation: newtypeValidation,
    functorValidation: functorValidation,
    applyValidation: applyValidation,
    applicativeValidation: applicativeValidation,
    altValidation: altValidation,
    semigroupValidation: semigroupValidation,
    monoidValidation: monoidValidation,
    semigroupoidValidation: semigroupoidValidation,
    categoryValidation: categoryValidation,
    emptyValidators: emptyValidators
};
